export default __webpack_public_path__ + "static/brochure-46d45e91476cefc5d509d857db23538f.jpg";